import React from 'react';
import './PopupHistory.css'
import api from '../api/client';

const PopupHistory = ({ data, onSelect, onClose, refreshHistory }) => {
    const handleDelete = async (recid) => {
        if (!window.confirm('Are you sure you want to delete this planning?')) return;
        
        try {
          await api.delete(`/api/sets_forecast/${recid}`);
          refreshHistory(); // Обновляем историю без перезагрузки
        } catch (error) {
          console.error('Delete failed:', error);
          alert('Failed to delete planning');
        }
      };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <h3>Planning History</h3>
          <button className="popup-close" onClick={onClose}>×</button>
        </div>
        <div className="popup-body">
          <div className="history-list">
            {data.map(item => (
              <div key={item.recid} className="history-item">
                <div className="history-info">
                  <span className="history-id">Planning #{item.recid}</span>
                  <span className="history-date">Created: {new Date(item.date_created).toLocaleDateString()}</span>
                </div>
                <div>
                    <button 
                    className="btn popup-btn__small"
                    onClick={() => onSelect(item.recid)}
                    >
                    Open
                    </button>
                    <button 
                        className="btn popup-btn__small btn-delete"
                        onClick={() => handleDelete(item.recid)}
                    >
                        Delete
                    </button>
                </div>
                
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupHistory;
